const FEATURE_FLAGS = process.env.REACT_APP_FEATURE_FLAGS ? process.env.REACT_APP_FEATURE_FLAGS.split(" ") : [];
export default FEATURE_FLAGS;
